import { render, staticRenderFns } from "./tabDrivingLicence.vue?vue&type=template&id=45ba1544&scoped=true&"
import script from "./tabDrivingLicence.vue?vue&type=script&lang=js&"
export * from "./tabDrivingLicence.vue?vue&type=script&lang=js&"
import style0 from "./tabDrivingLicence.vue?vue&type=style&index=0&id=45ba1544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ba1544",
  null
  
)

export default component.exports